import { render, staticRenderFns } from "./movie-categorys.vue?vue&type=template&id=37b8f7de&"
import script from "./movie-categorys.vue?vue&type=script&lang=ts&"
export * from "./movie-categorys.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports